import { useIntl } from "react-intl";

const AppsAndIntegrations = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "JiraSoftwarePricingPage.modalContents.AppsAndIntegrations.title",
            defaultMessage: "Apps and integrations"
        }),
        body: intl.formatMessage({
            id: "JiraSoftwarePricingPage.modalContents.AppsAndIntegrations.body",
            defaultMessage:
                "Seamlessly connect Jira to the tools you use. Improve your team's workflow with thousands of integrations, apps, and more with any integration that works for Jira Cloud."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
        </div>
    );
};

export default AppsAndIntegrations;
